import { render } from "./LabelMini.vue?vue&type=template&id=a998f1a2"
import script from "./LabelMini.vue?vue&type=script&lang=js"
export * from "./LabelMini.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__